let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ddz4Z")).then(() => parcelRequire('7Zzmn'));